import api from '@/api'

export default {
  isSecured: false,
  baseUrl: '//localhost/git/october/taps/api/',
  getFaq (data) {
    return api({
      url: '/faq',
      method: 'post',
      data
    })
  }
}



// WEBPACK FOOTER //
// ./src/api/faq.js